module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.editingCampaign ? 'Edit Campaign' : 'Create new campaign',
      "visible": _vm.dialogVisible,
      "top": "5vh"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.showCampaignForm) ? _c('campaign-form', {
    attrs: {
      "channels": _vm.channelList,
      "selectedChannels": _vm.selectedChannels,
      "loading": _vm.mutationLoading,
      "campaignToEdit": _vm.campaignData,
      "isEditing": _vm.editingCampaign,
      "plugins": _vm.plugins
    },
    on: {
      "onSelectedChannelsChanged": _vm.handleSelectedChannelsChanged,
      "onRequestTwitterAuth": _vm.handleRequestTwitterAuth,
      "onRequestFacebookAuth": _vm.handleRequestFacebookAuth,
      "onRequestInstagramAuth": _vm.handleRequestInstagramAuth,
      "onRequestEmailChannelCreate": _vm.handleRequestEmailChannelCreate,
      "onRequestWhatsappChannelCreate": _vm.handleRequestWhatsappChannelCreate,
      "onFormCancel": _vm.handleFormCancel,
      "onFormSave": _vm.handleFormSave
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showCampaignForm) ? _c('div', [_c('loader', {
    attrs: {
      "message": "Loading campaign detail"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('facebook-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showFacebookCreateDialog
    },
    on: {
      "onFacebookChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleFacebookVisibilityChange
    }
  }), _vm._v(" "), _c('email-channel-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showEmailCreateDialog
    },
    on: {
      "onEmailChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleEmailDialogVisibilityChange
    }
  }), _vm._v(" "), _c('whatsapp-web-channel-create-dialog', {
    attrs: {
      "isVisible": _vm.showWhatsappCreateDialog
    },
    on: {
      "onWhatsappChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleWhatsappDialogVisibilityChange
    }
  }), _vm._v(" "), _c('instagram-create-dialog', {
    attrs: {
      "me": _vm.me,
      "isVisible": _vm.showInstagramCreateDialog
    },
    on: {
      "onInstagramChannelAdded": _vm.refetchChannelList,
      "onVisibleChanged": _vm.handleInstagramVisibilityChange
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48f41f62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/campaign/CampaignManage.vue
// module id = 3265
// module chunks = 3